import { Eye, EyeOff } from 'lucide-react';
import { useState, type FormEvent } from 'react';

import { Button, Input } from '../../components/ui';

interface CredentialsFormProps {
  isSubmitting: boolean;
  onSubmit: (email: string, password: string) => void;
  onDirty: () => void;
}

export const CredentialsForm = ({ isSubmitting, onSubmit, onDirty }: CredentialsFormProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(email, password);
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="space-y-5">
        <div>
          <label htmlFor="email" className="mb-2 block text-sm font-medium text-brand-blue">
            E-postadress
          </label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="admin@careofcarl.com"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
              onDirty();
            }}
          />
        </div>

        <div>
          <label htmlFor="password" className="mb-2 block text-sm font-medium text-brand-blue">
            Lösenord
          </label>
          <div className="relative">
            <Input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              required
              placeholder="Ange ditt lösenord"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                onDirty();
              }}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 flex items-center pr-4 text-brand-blue/60 transition-all hover:text-brand-blue hover:scale-110 duration-300"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <Eye className={showPassword ? 'hidden' : 'block'} size={18} />
              <EyeOff className={showPassword ? 'block' : 'hidden'} size={18} />
              <span className="sr-only">Visa lösenord</span>
            </button>
          </div>
        </div>
      </div>

      <Button type="submit" loading={isSubmitting} variant="primary" size="lg" className="w-full">
        {isSubmitting ? 'Loggar in...' : 'Logga in'}
      </Button>
    </form>
  );
};
